import { createContext, useContext } from 'react'
import type {
    Escopo,
    FacetaId,
    Registro,
    ResumoVisual,
    ValorFaceta,
} from './escopo'
import type { useFacetaOptions } from './useFacetaOptions'

export type EscopoContextValue = {
    valor: Escopo
    setFaceta: (id: FacetaId, valor: ValorFaceta) => void
    toggleDemitidos: (incluir: boolean) => void
    limpar: () => void
    registrar: (registro: Registro) => () => void
    registro: Registro[]
    ativa: FacetaId | null
    setAtiva: (id: FacetaId) => void
    aberto: boolean
    setAberto: (aberto: boolean) => void
    dados: ReturnType<typeof useFacetaOptions>
    /** nome da empresa + badges por faceta, exibidos no botão do filtro */
    resumoVisual: ResumoVisual
    /** termo digitado na faceta ativa; a de funcionário busca no servidor */
    busca: string
    setBusca: (busca: string) => void
    /** nó do painel do shell cascata; null = fechado → partes não renderizam */
    painel: HTMLElement | null
    setPainel: (el: HTMLElement | null) => void
}

export const EscopoContext = createContext<EscopoContextValue | null>(null)

export function useEscopoContext(): EscopoContextValue {
    const contexto = useContext(EscopoContext)
    if (!contexto)
        throw new Error(
            'EscopoFuncionario: as partes precisam estar dentro de <EscopoFuncionario.Root>',
        )
    return contexto
}

/** Qual shell embrulha as partes — decide onde a parte renderiza. */
export const ShellContext = createContext<'cascata' | 'inline'>('cascata')
